export enum PragmaticValidationStatus
{
    Passed = 1,
    Failed = 2,
    Error = 3
}
